import { Spinner } from '@vkontakte/vkui';

export const DataLoadingScreen = () => {
	return <Spinner size="large" />;
};
